export const callbackRoute = {
  path: 'callback',
  url: '/callback',
  pathMatch: 'full',
  authenticationRequired: false,
  redirectTo: '/district-picker',
};
